import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faShoppingCart,
  faListAlt,
} from "@fortawesome/free-solid-svg-icons";
import Menu from "./MenuBottom.module.css";
import { Link, useLocation } from "react-router-dom";
import { getUserInfo } from "../../Api/BarestServices";

const MenuBottom = () => {
  const location = useLocation();
  const [ShoppingBasket, setShoppingBasket] = useState(false);
  const [Home, setHome] = useState(true);
  const [Orders, setOrders] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/") {
      setShoppingBasket(false);
      setHome(true);
      setOrders(false);
    }
    if (window.location.pathname === "/shopp") {
      setShoppingBasket(true);
      setHome(false);
      setOrders(false);
    }
    if (window.location.pathname === "/Orders") {
      setShoppingBasket(false);
      setHome(false);
      setOrders(true);
    }
  }, [location]);
  const [info, setInfo] = useState([]);
  useEffect(() => {
    UserInfo();
  }, []);
  const UserInfo = async () => {
    getUserInfo((succ, res) => {
      if (succ) {
        if (res.status === 0 || res.status === -2) {
          console.warn("کاربر وارد نشده!");
        } else {
          setInfo(res.info);
          localStorage.setItem("wallet", res.info.wallet);
        }
      } else {
        console.error("خطایی در سرور رخ داده است");
      }
    });
  };

  return (
    <ul className={Menu.menufixed}>
      <Link to="/shopp">
        <li
          className={
            ShoppingBasket ? Menu.menufixed__li__click : Menu.menufixed__li
          }
        >
          <FontAwesomeIcon icon={faShoppingCart} />
          <h2 className={Menu.h2}>
            {" "}
            سبد خرید 
            {info?.cart && info?.cart!=="0"&&<span className={Menu.OrderCount}>{info?.cart}</span>}
          </h2>
        </li>
      </Link>
      <Link to="/">
        <li className={Home ? Menu.menufixed__li__click : Menu.menufixed__li}>
          <FontAwesomeIcon icon={faHome} />
          <h2 className={Menu.h2}> خانه</h2>
        </li>
      </Link>
      <Link to="/Orders">
        <li className={Orders ? Menu.menufixed__li__click : Menu.menufixed__li}>
          <FontAwesomeIcon icon={faListAlt} />
          <h2 className={Menu.h2}>سفارشات</h2>
        </li>
      </Link>
    </ul>
  );
};
export default MenuBottom;
